import React from 'react';

import { components, ClearIndicatorProps } from 'react-select';

import { ClearIndicatorIcon } from 'assets/images';
import { OptionType } from 'utils/inputSelect';

import styles from './ClearIndicator.module.scss';

const ClearIndicator = (props: ClearIndicatorProps<OptionType>) => {
  return (
    <components.ClearIndicator {...props}>
      <ClearIndicatorIcon className={styles.crossIcon} />
    </components.ClearIndicator>
  );
};

export default ClearIndicator;
